// Function to load JSON data
function loadJSON(url, callback) {
  var xobj = new XMLHttpRequest();
  xobj.overrideMimeType("application/json");
  xobj.open("GET", url, true);
  xobj.onreadystatechange = function () {
    if (xobj.readyState == 4 && xobj.status == "200") {
      callback(JSON.parse(xobj.responseText));
    }
  };
  xobj.send(null);
}

// Function to set meta description
function setMetaDescription(jsonUrl, currentTags) {
  loadJSON(jsonUrl, function (data) {
    var description =
      "Check out our blog section for the latest news, updates, and tips about cell phone signal boosters.";

    currentTags.forEach(function (tag) {
      if (data[tag]) {
        description = data[tag];
      }
    });

    var metaTag = document.querySelector('meta[name="description"]');
    if (metaTag) {
      metaTag.setAttribute("content", description);
    } else {
      metaTag = document.createElement("meta");
      metaTag.setAttribute("name", "description");
      metaTag.setAttribute("content", description);
      document.head.appendChild(metaTag);
    }
  });
}

// Call the function to set the meta description when the document is ready
document.addEventListener("DOMContentLoaded", function () {
  var jsonUrl = document.getElementById("jsonUrl").value;
  var currentTags = document.getElementById("currentTags").value.split(",");

  setMetaDescription(jsonUrl, currentTags);
});
